import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const LogoContainer = styled.div`
  margin-bottom: 32px;
`;

export const SuccessPageStyles = styled(OnboardingPage)<{
  backgroundImage?: string;
}>`
  --success-payment-next-actions-border-bottom: 1px solid #fff;

  body.dark & {
    --success-payment-next-actions-border-bottom: 1px solid #ffffff4d;
  }

  ion-content {
    position: relative;
    --background: ${(props) =>
      props.backgroundImage
        ? `url(/assets/success-page/web-version/glowing.png) no-repeat center center / cover, url(${props.backgroundImage}) no-repeat top center / contain`
        : 'transparent'};

    background-color: #000000;
  }

  .image-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .content {
    position: absolute;
    bottom: 24px;
    left: 0;
    width: 100%;
    padding: 0 24px;
    z-index: 2;

    .questions-email {
      margin: 0 auto;
      border-top: 1px solid rgba(255, 255, 255, 0.3);
      padding-top: 20px;

      a {
        color: inherit;
      }
    }
  }
`;
